<template>
  <div class="RouteContainer">
    <app-audio :src="'./static/audio/' + landscapeContent.audio"></app-audio>

    <div class="container">
      <div class="row">
        <div class="col-sm-10 col-md-8 col-lg-8 Blurb text-center text-md-left mx-auto my-3">
          <h2 class="Blurb-title">{{ landscapeContent.title }}</h2>
          <p class="Blurb-body">{{ landscapeContent.intro }}</p>
          <p class="Blurb-blockquote mt-3 text-center">Select an area to explore ecosystems with and without wolves.</p>
        </div>
      </div>
    </div>

    <transition name="fade" mode="in-out">
      <app-background 
        :backgroundImg="'./static/images/landscape/' + landscapeContent.maps[0].backgroundImg" 
        v-if="!landscapeState" 
        :key="generateKey()"/>
      <app-background 
        :backgroundImg="'./static/images/landscape/' + landscapeContent.maps[1].backgroundImg" 
        v-else 
        :key="generateKey()"/>
    </transition>

    <div class="container">
      <app-landcape-map/>
    </div>

  </div>
</template>

<script>
import appAudio from './../partials/audio'
import appBackground from './../partials/background'
import appLandcapeMap from './../landscape/landscape-map'
import MixinHelper from './../mixins/helper'
export default {
  components: {
    appAudio,
    appBackground,
    appLandcapeMap
  },

  mixins: [ MixinHelper ],

  data () {
    return {
      landscapeState: false
    }
  },

  computed: {
    landscapeContent () {
      return this.$store.getters.landscapeContent
    }
  },

  beforeCreate () {
    this.$store.dispatch('getLocalData', 'landscape')
  }
}
</script>

<style lang="scss" scoped>
@import './../../assets/_variables.scss';

.Landscape-title {
  color: $offwhite;
  cursor: pointer;
  display: inline-block;
  font-size: 1.5em;
  font-weight: 500;
  text-transform: uppercase;
  transition: $transitionHover;
  &:hover {
    color: $darkgray;
  }
}

.Landscape-title.is-active {
  color: $darkgray;
  position: relative;
  &:hover {
    color: $offwhite;
  }
  &::after {
    background-color: $offwhite;
    content: '';
    position: absolute;
    bottom: -.25em;
    left: 0;
    width: 100%;
    height: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/routes/landscape.vue